import { useAppSelector } from '@shared/redux';
import type { CreateAgentFormValues } from '../lib/types';
import { useCreateAgentAgentCreatePostMutation } from '@shared/api';
import { authSelectors } from '@shared/redux/ducks/auth';

export const useCreateAgent = (onError?: () => void) => {
  const [createAgentMutation, { isLoading }] = useCreateAgentAgentCreatePostMutation();
  const currentOrganization = useAppSelector(authSelectors.selectCurrentOrganizationInfo);

  const createAgent = async (values: CreateAgentFormValues) => {
    try {
      const result = await createAgentMutation({
        organizationId: currentOrganization.id,
        createAgentData: {
          ...values,
        },
      }).unwrap();
      return result;
    } catch {
      onError?.();

      throw new Error();
    }
  };

  return { createAgent, isLoading };
};
